export default "__VITE_ASSET__CFkxyUJW__"